var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455 319L453 361L480 330Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 319L413 327L453 361Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 361L525 385L480 330Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 327L391 384L453 361Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 361L491 431L525 385Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573 320L531 284L480 330Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 330L531 284L455 319Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 319L402 271L413 327Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442 220L402 271L455 319Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 327L323 329L391 384Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 384L491 431L453 361Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 284L523 246L455 319Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442 220L394 248L402 271Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402 271L355 296L413 327Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 385L573 320L480 330Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 284L571 270L523 246Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 248L355 296L402 271Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562 410L576 377L525 385Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 385L576 377L573 320Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 246L442 220L455 319Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 431L562 410L525 385Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 319L571 270L573 320Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573 320L571 270L531 284Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 242L323 329L355 296Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 296L323 329L413 327Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562 410L598 372L576 377Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 377L598 372L573 320Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 500L471 487L392 507Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 384L471 487L491 431Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 431L524 504L562 410Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 329L320 398L391 384Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 507L471 487L391 384Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 487L524 504L491 431Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 246L435 174L442 220Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442 220L435 174L394 248Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 248L319 242L355 296Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 152L435 174L439 139Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 329L301 404L320 398Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 398L318 440L391 384Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 175L319 242L394 248Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 329L270 318L301 404Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 404L318 440L320 398Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 500L524 504L471 487Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562 410L594 480L598 372Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688 405L637 319L598 372Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598 372L637 319L573 320Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 440L392 507L391 384Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 500L448 551L524 504Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439 139L435 174L535 125Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 174L319 175L394 248Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 174L523 246L535 125Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 242L270 318L323 329Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 504L594 480L562 410Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 321L262 322L270 318Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 318L262 322L301 404Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 404L260 450L318 440Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 163L523 246L571 270Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 175L282 218L319 242Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 440L375 529L392 507Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 507L448 551L458 500Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 265L657 271L701 327Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 319L657 271L571 270Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625 206L571 163L571 270Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 244L251 321L270 318Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 322L239 327L301 404Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 529L448 551L392 507Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 572L635 511L594 480Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657 271L625 206L571 270Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 175L435 174L433 152Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 242L235 244L270 318Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 107L319 175L433 152Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 244L239 327L251 321Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 321L239 327L262 322Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 440L317 535L375 529Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 99L535 125L584 96Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 163L535 125L523 246Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 450L260 450L209 400Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701 327L657 271L637 319Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657 271L681 214L625 206Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 480L688 405L598 372Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 400L260 450L301 404Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 450L317 535L318 440Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688 405L701 327L637 319Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 531L317 535L260 450Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 600L472 600L448 551Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 572L594 480L524 504Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 480L690 476L688 405Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 171L235 244L282 218Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 218L235 244L319 242Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701 327L698 269L680 265Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 265L681 214L657 271Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 96L535 125L571 163Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 155L571 163L625 206Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 125L467 82L439 139Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439 139L348 107L433 152Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702 226L681 214L680 265Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679 157L636 155L625 206Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 600L524 504L448 551Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 600L571 572L524 504Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 99L467 82L535 125Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 338L209 400L239 327Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 327L209 400L301 404Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449 62L348 107L439 139Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 175L241 171L282 218Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 400L219 435L248 450Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 450L223 465L260 450Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 600L448 551L388 600Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 600L448 551L375 529Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 600L502 600L448 551Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 99L472 75L467 82Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 82L449 62L439 139Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686 490L690 476L635 511Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 511L690 476L594 480Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688 405L759 393L701 327Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698 269L702 226L680 265Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681 214L679 157L625 206Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753 216L702 226L698 269Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 572L641 538L635 511Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 455L248 450L219 435Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 455L223 465L248 450Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 405L218 455L219 435Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 600L388 600L317 535Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 535L388 600L375 529Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 538L686 490L635 511Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636 155L584 96L571 163Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 99L572 0L472 75Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633 90L584 96L636 155Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 98L241 171L319 175Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 244L179 234L239 327Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 0L449 62L472 75Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 75L449 62L467 82Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 35L323 98L348 107Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 107L323 98L319 175Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 600L251 531L195 600Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223 465L251 531L260 450Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702 226L679 157L681 214Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633 90L572 76L584 96Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 96L572 76L535 99Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 171L179 234L235 244Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 400L86 405L219 435Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 450L688 405L690 476Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 450L759 393L688 405Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 277L753 216L698 269Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702 226L753 216L679 157Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 531L304 600L317 535Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679 157L633 90L636 155Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 234L156 338L239 327Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 600L251 531L150 557Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 600L626 600L571 572Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 572L626 600L641 538Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 538L718 572L686 490Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757 529L750 450L690 476Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757 529L690 476L686 490Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449 62L387 35L348 107Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 98L237 80L241 171Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 0L387 35L449 62Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 289L698 269L701 327Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679 157L719 88L633 90Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 450L778 383L759 393Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759 393L778 383L701 327Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626 600L680 600L641 538Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 0L535 99L572 76Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 0L451 0L472 75Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 32L237 80L323 98Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 171L143 165L179 234Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 32L323 98L387 35Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 600L718 572L641 538Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 450L811 492L778 383Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 0L391 0L387 35Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 0L388 0L387 35Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 572L757 529L686 490Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 0L290 32L387 35Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849 385L811 289L778 383Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778 383L811 289L701 327Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 289L810 277L698 269Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 572L784 600L757 529Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 600L705 600L718 572Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581 0L572 76L636 0Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581 0L572 0L572 76Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 76L633 90L636 0Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 259L105 293L179 234Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 234L105 293L156 338Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 531L223 465L150 557Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719 88L679 157L783 146Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783 146L679 157L753 216Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 383L209 400L156 338Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 531L209 600L304 600Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 84L241 171L237 80Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 84L143 165L241 171Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 293L96 383L156 338Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 40L193 84L237 80Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 557L223 465L114 513Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814 162L783 146L753 216Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 165L92 259L179 234Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 362L86 387L96 383Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 362L96 383L105 293Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 513L223 465L218 455Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 405L209 400L96 383Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 387L86 405L96 383Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847 491L811 492L814 567Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757 529L811 492L750 450Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708 31L636 0L633 90Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708 31L633 90L719 88Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 266L825 222L810 277Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 277L825 222L753 216Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866 324L810 277L811 289Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 405L114 513L218 455Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 230L81 260L92 259Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 259L81 260L105 293Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 387L44 362L86 405Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 186L92 259L143 165Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 492L849 385L778 383Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 0L262 0L290 32Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 32L262 0L237 80Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825 222L814 162L753 216Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799 31L708 31L719 88Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801 90L719 88L783 146Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 0L198 40L237 80Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 128L99 146L143 165Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 515L118 548L114 513Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 513L118 548L150 557Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 557L148 600L195 600Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849 385L866 324L811 289Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 122L828 94L814 162Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 548L148 600L150 557Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 128L143 165L105 111Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 146L80 186L143 165Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708 31L691 0L636 0Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 0L691 0L708 31Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 492L847 491L849 385Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849 385L900 347L866 324Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814 567L811 492L757 529Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705 600L784 600L718 572Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 260L44 362L105 293Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 405L46 437L114 513Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 277L44 362L81 260Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 146L0 150L80 186Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 111L143 165L193 84Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828 94L809 107L814 162Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814 162L809 107L783 146Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784 600L814 567L757 529Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809 107L801 90L783 146Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 28L105 111L193 84Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 245L50 230L0 150Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 277L50 230L0 245Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 186L50 230L92 259Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 362L46 437L86 405Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 548L96 600L148 600Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 40L161 28L193 84Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 0L203 0L198 40Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 0L165 26L198 40Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 437L66 515L114 513Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 0L161 28L165 26Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 26L161 28L198 40Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 0L191 0L198 40Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 448L900 347L849 385Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866 324L900 266L810 277Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 191L814 162L825 222Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809 107L828 94L801 90Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801 90L799 31L719 88Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 347L900 266L866 324Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 515L96 600L118 548Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 266L900 234L825 222Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847 491L900 448L849 385Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 451L900 448L847 491Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 558L900 451L847 491Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784 600L836 600L814 567Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814 567L900 558L847 491Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802 0L799 31L900 18Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828 94L799 31L801 90Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799 31L768 0L708 31Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 0L150 0L165 26Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 28L94 43L105 111Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 230L80 186L0 150Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 362L0 367L46 437Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 437L0 504L66 515Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 515L0 600L96 600Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 277L0 367L44 362Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 234L900 191L825 222Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 146L0 140L0 150Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 230L0 277L81 260Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 146L100 128L0 140Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 367L0 441L46 437Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 0L94 43L161 28Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 18L799 31L828 94Z",
    fill: "#2ebee4",
    stroke: "#2ebee4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799 31L802 0L768 0Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 441L0 504L46 437Z",
    fill: "#025c87",
    stroke: "#025c87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836 600L900 558L814 567Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 191L900 122L814 162Z",
    fill: "#1791bb",
    stroke: "#1791bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 504L0 511L66 515Z",
    fill: "#1286b1",
    stroke: "#1286b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 140L100 128L0 91Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 91L100 128L105 111Z",
    fill: "#1c9cc6",
    stroke: "#1c9cc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 0L90 0L94 43Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 43L0 91L105 111Z",
    fill: "#00527c",
    stroke: "#00527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836 600L900 600L900 558Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 91L94 43Z",
    fill: "#28b3da",
    stroke: "#28b3da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 511L0 600L66 515Z",
    fill: "#09719c",
    stroke: "#09719c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 122L900 18L828 94Z",
    fill: "#056691",
    stroke: "#056691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 18L900 0L802 0Z",
    fill: "#0d7ba7",
    stroke: "#0d7ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 0L0 0L94 43Z",
    fill: "#22a7d0",
    stroke: "#22a7d0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoly);
export default __webpack_public_path__ + "static/media/poly.dc34d905e307a3141f0c3094ad022812.svg";
export { ForwardRef as ReactComponent };